
import axiosPos from '../axios/pos';
import axiosGateway from '../axios/gateway'

/**
 * 获取大区列表
 * @param country
 * @returns
 */
 export const getWechatList = async (): Promise<Array<KeyValue>> => {
  return axiosPos.get(`/wx/wechats`,{publicted:true,toast:true}).then(({ data }) => {
    return data as Array<KeyValue>;
  });
};

/**
 * 获取大区列表（新）
 * @param country
 * @returns
 */
export const simpleWechatForCountry = async (): Promise<KeyValue> => {
  return axiosGateway.get(`/api/common/simpleWechatForCountry`,{publicted:true,toast:true}).then(({ data }) => {
    return data as KeyValue;
  });
};

/**
 * 注册申请
 * @param data
 */
 export const register = async (data: KeyValue) => {
  return axiosPos.post(`./forminfos`, data,{publicted:true,toast:true});
};

/**
 * 注册申请(新)
 * @param data
 */
export const registerNew = async (data: KeyValue) => {
  return axiosGateway.post(`/api/merchantadmin/unauth/forminfos/applyStores`, data,{publicted:true,toast:true});
};
